import type { BackupSelection, BackupSummary } from "@app/core";
import { create } from "zustand";

export type BackupImportResult =
  | { kind: "cancel" }
  | { kind: "import"; mode: "replace" | "merge"; selection: BackupSelection };

interface State {
  open: boolean;
  summary: BackupSummary | null;
  resolveFn: ((r: BackupImportResult) => void) | null;
  ask: (summary: BackupSummary) => Promise<BackupImportResult>;
  resolve: (r: BackupImportResult) => void;
}

/** Drives the "Load from file" dialog: pick which categories to import and
 *  whether to replace or merge. */
export const useBackupImportStore = create<State>((set, get) => ({
  open: false,
  summary: null,
  resolveFn: null,
  ask: (summary) =>
    new Promise((resolve) => {
      set({ open: true, summary, resolveFn: resolve });
    }),
  resolve: (r) => {
    const fn = get().resolveFn;
    set({ open: false, summary: null, resolveFn: null });
    fn?.(r);
  },
}));
